import { useSelector } from 'react-redux';
import { SALES } from '../constants';

import { getDecisionNodeAtPath } from 'extractFromState';
import useAgentAssistSales from './useAgentAssistSales';
import useAgentAssistTroubleshooter from './useAgentAssistTroubleshooter';

export default function useAgentAssist() {
  const decisionNode = useSelector(getDecisionNodeAtPath);

  if (decisionNode.type === SALES) {
    return useAgentAssistSales;
  }

  return useAgentAssistTroubleshooter;
}
